<template>
  <div class="wrap">
    <div class="chapter_box" v-if="!empty">
      <el-tree
        :data="list"
        node-key="chapterId"
        :props="{
          children: 'children',
          label: 'title',
        }"
        :default-expand-all="true"
      >
        <span
          class="custom-tree-node"
          :class="{ catalog: !data.parentId }"
          slot-scope="{ data }"
        >
          <span>
            <span class="left-icon" v-if="data.children">
              <!-- <img
                :src="
                  node.expanded
                    ? require('@/assets/images/icons/close.png')
                    : require('@/assets/images/icons/open.png')
                "
                alt=""
              /> -->
            </span>
            <!-- <span class="left-dot" v-else> </span> -->
            <span>{{ data.title }}</span>
            <!-- <el-tag
              v-if="data.sz"
              style="margin-left: 10px"
              effect="dark"
              size="mini"
              >实训</el-tag
            > -->
            <el-tag
              v-if="data.mock"
              style="margin-left: 10px"
              effect="dark"
              color="teal"
              size="mini"
              >仿真实操</el-tag
            >
            <!-- <el-tag
              v-if="data.teamGrade"
              style="margin-left: 10px"
              effect="dark"
              type="success"
              size="mini"
              >评价</el-tag
            > -->
          </span>
          <span v-if="data.type == 'CHAPTER' && !data.disabled">
            <!-- <uploadFile
              style="display: inline-block"
              @success="uploadSuccess"
              @click.native.stop="params.classChapterId = data.classChapterId"
            >
              <el-button class="btn" size="mini" type="info" plain
                >附件上传</el-button
              >
            </uploadFile> -->

            <el-button
              class="btn"
              size="mini"
              type="text"
              plain
              v-if="data.status == 'OPEN'"
              @click="handleEnd(data.classChapterId, 'CLOSE')"
              >关闭</el-button
            >
            <el-button
              class="btn"
              size="mini"
              type="text"
              plain
              v-else
              @click="handleEnd(data.classChapterId, 'OPEN')"
              >开启</el-button
            >
            <el-button
              class="btn"
              size="mini"
              type="text"
              plain
              @click="goDetail(data)"
              >上课</el-button
            >
            <el-button
              class="btn"
              size="mini"
              type="text"
              plain
              @click="
                handleSettle(
                  data.classChapterId,
                  data.chapterId,
                  data.title,
                  data.syComplete
                )
              "
              >{{ data.complete ? "结算" : "成绩" }}</el-button
            >
          </span>
        </span>
      </el-tree>
    </div>
    <el-empty description="暂无章节~" :image-size="200" v-else></el-empty>

    <el-dialog title="提示" :visible.sync="showTips" width="30%" center>
      <p style="margin-bottom: 10px">已推送的章节中有未生成成绩的：</p>
      <p v-for="item in notTitles" :key="item" style="line-height: 1.5">
        {{ item }}
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showTips = false">去生成</el-button>
        <el-button type="primary" @click="goDetail(currentChapter, true)"
          >我知道了，继续上课</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="showsyComplete" width="30%" center>
      <p style="text-align: center">本章节尚未进行素养评定</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goSy">去评定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { handleTree } from "@/utils";
import uploadFile from "@/components/uploadFile";
import { addAnnex } from "@/api/annex";
import {
  chapterList,
  startClass,
  editChapter,
  settlement,
} from "@/api/chapter";
export default {
  name: "chapters",
  components: {
    uploadFile,
  },
  data() {
    return {
      sections: [],
      list: [],
      empty: false,
      params: {
        classChapterId: "",
      },
      showTips: false,
      currentChapter: {},
      notTitles: [],
      showsyComplete: false,
      currentClassChapterId: null,
      currentChapterId: null,
      currentChapterTitle: "",
    };
  },
  created() {
    this.getChapterList();
  },
  methods: {
    // 章节列表
    getChapterList() {
      this.$loading.show();
      chapterList({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = handleTree(res.data, "chapterId");
          // console.log(this.list);
          this.empty = this.list && this.list.length > 0 ? false : true;
          this.sections = res.data.filter((item) => {
            return item.type == "CHAPTER";
          });
        } else {
          console.log(res.msg);
        }
      });
    },
    goDetail(chapter, n) {
      if (!n) {
        let opened = this.sections.filter((item) => {
          return item.status == "OPEN";
        });
        let notComplete = opened.filter((item) => {
          return !item.complete;
        });
        if (notComplete.length > 0) {
          let classChapterIdArr =
            JSON.parse(localStorage.getItem("classChapterIdArr")) || [];
          let notFirst = classChapterIdArr.some((item) => {
            return item == chapter.classChapterId;
          });
          if (!notFirst) {
            classChapterIdArr.push(chapter.classChapterId);
            localStorage.setItem(
              "classChapterIdArr",
              JSON.stringify(classChapterIdArr)
            );
          } else {
            this.notTitles = [];
            notComplete.forEach((item) => {
              this.notTitles.push(item.title);
            });

            this.showTips = true;
            this.currentChapter = chapter;
            return;
          }
        }
      }
      this.$router.push({
        path: "/courseDetail",
        query: {
          ...this.$route.query,
          classChapterId: chapter.classChapterId,
          chapterId: chapter.chapterId,
          chapterTitle: chapter.title,
        },
      });
    },
    // 上传成功
    uploadSuccess(file) {
      this.params.name = file.name;
      this.params.type = file.type;
      this.params.url = file.url;
      this.params.size = file.size;
      addAnnex(this.params).then((res) => {
        if (res.code == 0) {
          this.$message.success("上传成功");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 推送课程
    // handleBegin(classChapterId) {
    //   this.$confirm(`本操作不可逆,确定要推送章节吗？`, {
    //     type: "warning",
    //   })
    //     .then(() => {
    //       this.$loading.show();
    //       startClass(classChapterId).then((res) => {
    //         this.$loading.hide();
    //         if (res.code == 0) {
    //           this.getChapterList();
    //           this.$message.success("该章节已开放");
    //         } else {
    //           this.$message.error(res.msg);
    //         }
    //       });
    //     })
    //     .catch(() => {});
    // },
    // 取消推送
    handleEnd(classChapterId, status) {
      this.$loading.show();
      editChapter({ classChapterId, status }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.getChapterList();
          this.$message.success(
            status == "CLOSE" ? "该章节已关闭" : "该章节已开放"
          );
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 成绩生成
    handleSettle(classChapterId, chapterId, title, syComplete) {
      if (!syComplete) {
        this.currentClassChapterId = classChapterId;
        this.currentChapterId = chapterId;
        this.currentChapterTitle = title;
        this.showsyComplete = true;
        return;
      }
      this.$confirm(`确定要生成本章节的成绩吗？`, {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          settlement(classChapterId).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("成绩已生成");
              this.getChapterList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    goSy() {
      this.showsyComplete = false;
      this.$router.push({
        path: "/courseDetail/appraise",
        query: {
          ...this.$route.query,
          classChapterId: this.currentClassChapterId,
          chapterTitle: this.currentChapterTitle,
        },
      });
    },
    append() {},
    remove(node, data) {
      console.log(node, data);
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  margin-bottom: 30px;

  .chapter_box {
    background-color: #fff;
    ::v-deep .el-tree {
      .el-tree-node {
        .el-tree-node__content {
          height: 40px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.05);
          .el-tree-node__expand-icon {
            display: none;
          }
        }
      }
    }
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      padding: 0 16px;
      height: 40px;
      &.catalog {
        font-size: 17px;
        color: #303133;
        font-weight: bold;
        // background-color: #0080802b;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      }
      .left-icon {
        margin-right: 16px;
        img {
          width: 18px;
          height: 18px;
        }
      }
      .left-dot {
        display: inline-block;
        margin: 0 16px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: teal;
      }
      .btn {
        margin-left: 10px;
      }
    }
  }

  .catalog_row,
  .row {
    line-height: 40px;
    text-align: left;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    &.catalog_row {
      border-bottom: none;
    }
    &.row {
      padding: 0 15px;
      transition: all 0.3s ease;

      &:hover {
        background-color: rgb(245, 245, 245);
      }
    }

    .catalog_title,
    .title {
      display: inline-block;
      margin-left: 16px;
      max-width: 715px;
      height: 40px;
      font-size: 16px;
      // font-weight: bold;
      color: #606266;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      vertical-align: middle;
      &.catalog_title {
        max-width: 100%;
        font-size: 17px;
        color: #303133;
        font-weight: bold;
      }
    }

    .btns {
      float: right;

      .btn {
        margin-left: 10px;
        font-size: 14px;
      }
    }
  }
}
</style>